import {PolicyPreLapse as PolicyPreLapseLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

export type PolicyPreLapseProps = {
  policyPreLapseLetter: PolicyPreLapseLetter;
};

const PolicyPreLapse = (props: PolicyPreLapseProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.policyPreLapseLetter.date)} />
      <CardField name="Agent Number" value={props.policyPreLapseLetter.agentNumber} />
      <CardField name="Insured Name" value={props.policyPreLapseLetter.insuredName} ddprivacy="mask"/>
      <CardField name="Owner Name" value={props.policyPreLapseLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.policyPreLapseLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Policy Number" value={props.policyPreLapseLetter.policyNumber} ddprivacy="mask"/>
    </>
  );
};

export default PolicyPreLapse;
